import React from "react";
import s from "~/components/common/NoFoundEntity/NoFountEntity.module.scss";

interface Props {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  hideControls?: boolean;
  onClick?: () => void;
}

const NoFountEntity: React.FC<Props> = ({
  title = "Нет данных",
  subtitle = "Расскажите нам об этом!",
  buttonText = "Сообщить",
  hideControls = false,
  onClick,
}) => {
  return (
    <div className={s.noData}>
      <p className={"headline-2 " + s.noDataTitle}>{title}</p>
      <p className={s.noDataText}>{subtitle}</p>
      {!hideControls && onClick && (
        <button className="button" onClick={onClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default NoFountEntity;
